'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
Entry.RenderView = /*#__PURE__*/function () {
  function RenderView(dom, align, scale, parserType) {
    (0, _classCallCheck2["default"])(this, RenderView);
    (0, _defineProperty2["default"])(this, "schema", {
      code: null,
      dragBlock: null,
      closeBlock: null,
      selectedBlockView: null
    });
    this._align = align || 'CENTER';
    if (typeof dom === 'string') {
      dom = $("#".concat(dom));
    } else {
      dom = $(dom);
    }
    if (dom.prop('tagName') !== 'DIV') {
      return console.error('Dom is not div element');
    }
    this.view = dom;
    this.viewOnly = true;
    this.suffix = 'renderView';
    this._scale = scale === undefined ? 1 : scale;
    this._parserType = parserType;
    this.visible = true;
    this.disableMouseEvent = true;
    this._svgId = "renderView_".concat(new Date().getTime());
    this._generateView();
    this.offset = this.svgDom.offset();
    this._minBlockOffsetX = 0;
    this._setSize();
    this.svg = Entry.SVG(this._svgId, this.svgDom[0]);
    Entry.Utils.addFilters(this.svg, this.suffix, true);
    if (this.svg) {
      this.svgGroup = this.svg.elem('g');
      this.svgThreadGroup = this.svgGroup.elem('g');
      this.svgThreadGroup.board = this;
      this.svgBlockGroup = this.svgGroup.elem('g');
      this.svgBlockGroup.board = this;
      this.svgCommentGroup = this.svgGroup.elem('g');
      this.svgCommentGroup.board = this;
    }
  }
  return (0, _createClass2["default"])(RenderView, [{
    key: "_generateView",
    value: function _generateView() {
      var parent = this.view;
      this.renderViewContainer = Entry.Dom('div', {
        "class": 'renderViewContainer',
        parent: parent
      });
      this.svgDom = Entry.Dom($("<svg id=\"".concat(this._svgId, "\" class=\"renderView\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"></svg>")), {
        parent: this.renderViewContainer
      });
    }
  }, {
    key: "changeCode",
    value: function changeCode(code, resizeImmediately) {
      if (!(code instanceof Entry.Code)) {
        return console.error('You must inject code instance');
      }
      this.code = code;
      if (!this.svg) {
        this.svg = Entry.SVG(this._svgId, this.svgDom[0]);
        this.svgGroup = this.svg.elem('g');
        this.svgThreadGroup = this.svgGroup.elem('g');
        this.svgThreadGroup.board = this;
        this.svgBlockGroup = this.svgGroup.elem('g');
        this.svgBlockGroup.board = this;
        this.svgCommentGroup = this.svgGroup.elem('g');
        this.svgCommentGroup.board = this;
      }
      code.createView(this);
      this.align();
      this.resize(resizeImmediately);
    }
  }, {
    key: "align",
    value: function align() {
      var threads = this.code.getThreads();
      if (!threads || threads.length === 0) {
        return;
      }
      var vPadding = 15;
      var marginFromTop = 0;
      var hPadding = this._getHorizontalPadding();
      for (var i = 0, len = threads.length; i < len; i++) {
        var thread = threads[i];
        var block = thread.getFirstBlock();
        var blockView = block.view;
        var height = blockView.svgGroup.getBBox().height;
        var xPos = 0;
        var extensions = $(blockView.svgGroup).find('.extension');
        if (extensions) {
          for (var j = 0; j < extensions.length; j++) {
            var ext = extensions[j];
            var currentXpos = parseFloat(ext.getAttribute('x'));
            xPos = Math.min(xPos, currentXpos);
          }
        }
        this._minBlockOffsetX = Math.min(this._minBlockOffsetX, blockView.offsetX);
        blockView.moveTo(hPadding - xPos - blockView.offsetX, marginFromTop - blockView.offsetY, false);
        marginFromTop += height + vPadding;
      }
      this._setSize();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.view.addClass('entryRemove');
    }
  }, {
    key: "show",
    value: function show() {
      this.view.removeClass('entryRemove');
    }
  }, {
    key: "_setSize",
    value: function _setSize() {
      if (this.svgDom) {
        this._svgWidth = this.svgDom.width();
        this.offset = this.svgDom.offset();
      }
      if (this.svgGroup) {
        this._bBox = this.svgGroup.getBBox();
      }
    }
  }, {
    key: "bindCodeView",
    value: function bindCodeView(codeView) {
      this.svgBlockGroup.remove();
      this.svgThreadGroup.remove();
      this.svgBlockGroup = codeView.svgBlockGroup;
      this.svgThreadGroup = codeView.svgThreadGroup;
      this.svgCommentGroup = codeView.svgCommentGroup;
      this.svgGroup.appendChild(this.svgThreadGroup);
      this.svgGroup.appendChild(this.svgBlockGroup);
      this.svgGroup.appendChild(this.svgCommentGroup);
    }
  }, {
    key: "resize",
    value: function resize(isImmediate) {
      if (!this.svg || !this._bBox) {
        return;
      }
      if (isImmediate) {
        run.call(this);
      } else {
        setTimeout(function () {
          run.call(this);
        }.bind(this), 0);
      }
      function run() {
        this._setSize();
        var width = Math.round(this._bBox.width);
        var height = Math.round(this._bBox.height);
        //svg is not on the screen
        if (width === 0 || height === 0) {
          return;
        }
        $(this.svg).css({
          width: width + this._getHorizontalPadding() - this._minBlockOffsetX + 5,
          height: height + 5
        });

        //double check
        setTimeout(function () {
          var bBox = this.svgGroup.getBBox();
          if (Math.round(bBox.width) !== width || Math.round(bBox.height) !== height) {
            this.resize();
          }
        }.bind(this), 1000);
      }
    }
  }, {
    key: "setDomSize",
    value: function setDomSize(isImmediate) {
      if (this.svgBlockGroup) {
        this.svgBlockGroup.attr('transform', 'scale(1)');
      }
      this.code.view.reDraw();
      this.align();
      this.resize(isImmediate);
      if (this._scale !== 1) {
        window.setTimeout(function () {
          this.svgBlockGroup.attr('transform', 'scale(%scale)'.replace('%scale', this._scale));
          this.align();
          this.resize();
        }.bind(this), 0);
      }
    }
  }, {
    key: "_getHorizontalPadding",
    value: function _getHorizontalPadding() {
      var marginMap = {
        LEFT: 20,
        LEFT_MOST: 0
      };
      var ret = marginMap[this._align];
      return ret !== undefined ? ret : this.svgDom.width() / 2;
    }
  }, {
    key: "getBlockSyntax",
    value: function getBlockSyntax(block, renderMode) {
      var syntax = null;
      if (renderMode === 2) {
        if (!this._parser) {
          this._parser = new Entry.Parser(null, null);
        }
        this._parser.setParser(1, this._parserType);
        if (this._parser._execParser) {
          syntax = this._parser._execParser.searchSyntax(block);
        }
      }
      return syntax;
    }
  }, {
    key: "setParserType",
    value: function setParserType(parserType) {
      this._parserType = parserType;
    }
  }]);
}();